import { UserManager } from 'oidc-client';
let userManager;
export const getUserManager = () => {
  return userManager;
};
export const removeUserManager = () => {
  userManager = undefined;
};
export const authenticationService = configuration => {
  if (userManager) {
    return userManager;
  }
  userManager = new UserManager(configuration);
  return userManager;
};
//# sourceMappingURL=authentication-service.js.map